import { PolicyDashboardEventsModule, SignatureTrackingModule } from '@folio/modules';
import { Stack } from '@folio/components/ui/flex';

export function PolicyDashboardEvents() {
  return (
    <Stack>
      <PolicyDashboardEventsModule stopFunnelBasePath="/policies" />
      <SignatureTrackingModule />
    </Stack>
  );
}
